import React from 'react';
import { useHistory } from 'react-router-dom';
import checkImg from 'assets/check-circle-green.svg';
import styles from './style.module.css';

const ExemptionSaved = () => {
  const history = useHistory();

  return (
    <div className="coop-l-container">
      <div className={`coop-l-large-6 ${styles.container}`}>
        <img src={checkImg} className={styles.icon} alt="Green tick" />
        <h2 className={styles.header}>Done</h2>
        <p>Your exemption details have been updated.</p>
        <button
          className={`coop-btn coop-btn--primary ${styles.button}`}
          onClick={() => history.push('/pharmacy/dashboard/account')}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default ExemptionSaved;
